import { Navigate, type RouteObject } from 'react-router';

const MobileRoutes: RouteObject[] = [
    {
        path: '*',
        element: <Navigate to="/no-mobile-page" />,
    },
];

export default MobileRoutes;
